/**
 * Target configuration for mission CONFIANCE
 * Allows setting positive ratio targets per platform/segment
 */
import React from 'react';
import { Box, Typography, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { colors } from '../../styles/colors';

const SEGMENTS = [
  { id: 'platform', label: 'Par plateforme' },
  { id: 'source', label: 'Par source' },
];

const PLATFORMS = ['facebook', 'instagram', 'twitter', 'linkedin', 'news', 'web'];

const TargetConfiance = ({ config = {}, onChange, missionColor }) => {
  const segmentBy = config.segment_by || 'platform';
  const targets = config.targets || {};

  const handleSegmentChange = (e) => {
    onChange({ ...config, mission: 'confiance', segment_by: e.target.value, targets: {} });
  };

  const handleTargetChange = (key, value) => {
    const updated = { ...targets, [key]: parseInt(value, 10) || 0 };
    onChange({ ...config, mission: 'confiance', segment_by: segmentBy, targets: updated });
  };

  return (
    <Box sx={{ p: 2, borderLeft: `3px solid ${missionColor}`, borderRadius: 2, bgcolor: colors.ivory }}>
      <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontSize: '0.82rem', fontWeight: 600, color: colors.charcoal, mb: 1.5 }}>
        Ciblage Confiance
      </Typography>

      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel>Segmenter par</InputLabel>
        <Select value={segmentBy} label="Segmenter par" onChange={handleSegmentChange}>
          {SEGMENTS.map((s) => (
            <MenuItem key={s.id} value={s.id}>{s.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontSize: '0.75rem', color: colors.textMed, mb: 1 }}>
        Objectif % positif par segment
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {PLATFORMS.map((p) => (
          <Box key={p} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontSize: '0.78rem', color: colors.text, width: 80, textTransform: 'capitalize' }}>
              {p}
            </Typography>
            <TextField
              size="small"
              type="number"
              placeholder="70"
              value={targets[p] || ''}
              onChange={(e) => handleTargetChange(p, e.target.value)}
              inputProps={{ min: 0, max: 100 }}
              sx={{ width: 80 }}
            />
            <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontSize: '0.72rem', color: colors.textLight }}>%</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TargetConfiance;
